import { AuthStorage } from "utils/auth-storage";
import {
  Modal,
  Tabs,
  List,
  Button,
  Space,
  Spin,
  Tag,
  Card,
  Skeleton,
  Dropdown,
  Select,
  Cascader,
  DatePicker,
  Tooltip,
} from "antd";
import LoadingComponent from "components/loading-component";
import React, { useEffect, useState } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import RestoreIcon from "@mui/icons-material/Restore";
import { Block } from "@material-ui/icons";
import { CheckOutlined } from "@ant-design/icons";
import { WarehouseServices } from "apis/Services/WarehouseService";
import toast from "react-hot-toast";
import moment from "moment";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { EditRow, reloadProjects } from "redux/project-reducer";
import { ProjectServices } from "apis/Services/ProjectService";

function ItemsShippedModal({
  itemsShippedData,
  itemsShippedModal,
  itemsShippedHistoryData,
  isitemsShippedLoading,
  transfersToProjectInventoryHistory,
  setItemsShippedModal,
  projectID,
  accessLevel,
  projectDetails,
  editedItems,
}) {
  const [projectAddressMap, setProjectAddressMap] = useState({});
  const [selectedEntryID, setSelectedEntryID] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedSubDivision, setSelectedSubDivision] = useState(null);
  const [selectedActualDeliveryDate, setSelectedActualDeliveryDate] = useState(
    dayjs().format("MM-DD-YYYY"),
  );
  const dispatch = useDispatch();

  // Call data function when modal opens
  useEffect(() => {
    if (itemsShippedModal) {
      transfersToProjectInventoryHistory();
      getProjectsAddress();
    }
  }, [itemsShippedModal]);

  function getProjectsAddress() {
    let company_id = AuthStorage.getItem("company_id");
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getJobSites(ReqObj)
      .then((res) => {
        if (res) {
          const map = res.reduce((acc, item) => {
            acc[item.name] = item.address;
            return acc;
          }, {});

          setProjectAddressMap(map);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const onCancel = () => {
    setItemsShippedModal(false);
  };

  const handleChange = (value) => {
    const divisionName = value[0]; // first level
    const subdivisionName = value[1]; // second level
    const entryID = value[value.length - 1]; // last level

    setSelectedDivision(divisionName);
    setSelectedSubDivision(subdivisionName);
    setSelectedEntryID(entryID);

    console.log("Division:", divisionName);
    console.log("Subdivision:", subdivisionName);
    console.log("EntryID:", entryID);
  };

  const options = Object.entries(projectDetails?.content || []).map(
    ([divisionName, subdivisions]) => ({
      value: divisionName,
      label: (
        <Tooltip title={divisionName} placement="right">
          {divisionName}
        </Tooltip>
      ),
      searchValue: divisionName,
      children: Object.entries(subdivisions).map(
        ([subdivisionName, items]) => ({
          value: subdivisionName,
          label: (
            <Tooltip title={subdivisionName} placement="right">
              {subdivisionName}
            </Tooltip>
          ),
          searchValue: subdivisionName,
          children: items.map((item) => {
            const labelText = item.specTitle || item.specNumber || "";
            return {
              value: item.entryID,
              label: (
                <Tooltip title={labelText} placement="right">
                  {labelText}
                </Tooltip>
              ),
              searchValue: labelText,
            };
          }),
        }),
      ),
    }),
  );

  const filter = (inputValue, path) => {
    return path.some((option) =>
      option.searchValue?.toLowerCase().includes(inputValue.toLowerCase()),
    );
  };

  const displayRender = (labels) => labels[labels.length - 1];

  const nonWorkingDays = projectDetails?.nonWorkingDays || {};

  const isDateDisabled = (
    date,
    isContractIssuedReleaseOrActualDeliveryDate,
  ) => {
    // Handling Holidays
    const disabledDatesArray = [];
    Object.values(nonWorkingDays).forEach((holiday) => {
      var currDate = moment(holiday["startDate"], "MM/DD/YYYY").startOf("day");
      var lastDate = moment(holiday["finishDate"], "MM/DD/YYYY").startOf("day");
      disabledDatesArray.push(moment(currDate).format("YYYY-MM-DD"));
      while (currDate.add(1, "days").diff(lastDate) < 0) {
        disabledDatesArray.push(moment(currDate).format("YYYY-MM-DD"));
      }
      disabledDatesArray.push(moment(lastDate).format("YYYY-MM-DD"));
    });

    // Function to check if a date is a weekend
    const isWeekend = (dateToCheck) => [0, 6].includes(dateToCheck.day());

    const isFutureDate = (dateToCheck) => dateToCheck.isAfter(moment(), "day");

    if (isContractIssuedReleaseOrActualDeliveryDate) {
      // Disable non-working days, weekends, and future dates for contractIssuedRelease and ActualDeliveryDate
      return (
        date &&
        (disabledDatesArray.includes(date.format("YYYY-MM-DD")) ||
          isWeekend(date) ||
          isFutureDate(date))
      );
    } else {
      return (
        date &&
        (disabledDatesArray.includes(date.format("YYYY-MM-DD")) ||
          isWeekend(date))
      );
    }
  };

  const pendingTransfersTab = (
    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
      <List
        dataSource={itemsShippedData || []}
        loading={isitemsShippedLoading}
        renderItem={(transfer, index) => (
          <Card
            className=" w-100  bg-light bg-opacity-50"
            title={
              <div className="pt-3 pb-1">
                <div className="d-flex flex-column flex-lg-row justify-content-between mb-2 align-items-center gap-3">
                  {/* Left side - Transfer ID and Status */}
                  <div className="d-flex align-items-center  mb-3 mb-lg-0 ">
                    <Tag
                      className="flex items-center justify-center align-items-center fw-bold"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color={statusColors[transfer.currentStatus] || "default"}
                    >
                      {transfer.currentStatus === "Pending" && (
                        <RestoreIcon
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}

                      {transfer.currentStatus === "In Transit" && (
                        <LocalShippingOutlinedIcon
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}

                      {transfer.currentStatus === "Delivered" && (
                        <Inventory2OutlinedIcon
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}

                      {transfer.currentStatus === "Cancelled" && (
                        <Block
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}
                    </Tag>

                    <div className="d-flex flex-column justify-content-start gap-0">
                      <div>
                        <h6
                          className="fw-bold m-0 p-0"
                          style={{ fontSize: "0.9rem" }}
                        >
                          Transfer #{transfer.transferID}
                        </h6>
                      </div>
                      <div>
                        <Tag
                          color={
                            statusColors[transfer.currentStatus] || "default"
                          }
                          bordered={false}
                          className="rounded-5"
                          style={{ fontSize: "0.7rem" }}
                        >
                          {transfer.currentStatus}
                        </Tag>
                      </div>
                    </div>
                  </div>

                  {/* Right side  */}
                  <div className="d-flex flex-column flex-md-row gap-3 gap-md-5 justify-content-start justify-content-md-end align-items-start align-items-md-center">
                    <div className="d-flex flex-column text-md-end">
                      <span className="fw-bold fs-6  opacity-75">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(
                          (transfer.items || []).reduce(
                            (sum, item) => sum + item.unitPrice * item.quantity,
                            0,
                          ),
                        )}
                      </span>
                      <small className=" opacity-50">
                        {transfer.createdAt}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            }
            style={{ marginBottom: 16 }}
          >
            <div className=" d-flex justify-content-center align-items-center flex-column">
              <div className=" d-flex w-100 justify-content-md-start align-self-start flex-wrap gap-3 justify-content-start py-0">
                <div>
                  {transfer.items.map((item, index) => (
                    <div key={index}>
                      <div
                        className="d-flex flex-wrap justify-content-start px-1 py-1"
                        style={{ columnGap: "1rem", rowGap: "1rem" }}
                      >
                        {/* Material Info */}
                        <div
                          className="d-md-flex flex-md-row gap-2 align-items-center"
                          style={{ minWidth: "130px" }}
                        >
                          <Inventory2OutlinedIcon
                            style={{ fontSize: "1rem" }}
                            className="opacity-50"
                          />
                          <div className="d-flex flex-column text-start">
                            <small
                              style={{
                                fontSize: "0.85rem",
                                lineHeight: "1.2",
                                fontWeight: "bold",
                              }}
                            >
                              {item.materialName}
                            </small>
                            <small
                              className="opacity-50"
                              style={{
                                fontSize: "0.75rem",
                                lineHeight: "1.2",
                              }}
                            >
                              SKU: {item.sku}
                            </small>
                            {item?.itemVendor ? (
                              <small
                                className="opacity-50"
                                style={{
                                  fontSize: "0.75rem",
                                  lineHeight: "1.2",
                                }}
                              >
                                Vendor: {item.itemVendor}
                              </small>
                            ) : null}
                            <small
                              // className="opacity-50"
                              style={{
                                fontSize: "0.9rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {item?.category || ""}
                            </small>
                            <small
                              // className="opacity-50"
                              style={{
                                fontSize: "0.9rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {item?.subcategory || ""}
                            </small>
                          </div>
                        </div>

                        {/* Location Info */}
                        <div
                          className="d-md-flex flex-md-row gap-2 align-items-center"
                          style={{ minWidth: "130px" }}
                        >
                          <LocationOnOutlinedIcon
                            style={{ fontSize: "1rem" }}
                            className="opacity-50"
                          />
                          <div className="d-flex flex-column text-start">
                            <small
                              style={{
                                fontSize: "0.85rem",
                                lineHeight: "1.2",
                                fontWeight: "bold",
                              }}
                            >
                              {transfer.toLocation}
                            </small>
                            <small
                              className="opacity-75"
                              style={{
                                fontSize: "0.75rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {Object.keys(projectAddressMap).length > 0 ? (
                                projectAddressMap[transfer.toLocation] ||
                                "No address provided"
                              ) : (
                                <Skeleton.Input
                                  style={{ width: 80, height: 12 }}
                                  active
                                  size="small"
                                />
                              )}
                            </small>
                            <small
                              style={{
                                fontSize: "0.75rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {transfer.toSubLocation}
                            </small>
                          </div>
                        </div>

                        {/* Quantity Info */}
                        <div
                          className="d-flex justify-content-end"
                          style={{ minWidth: "160px" }}
                        >
                          <div className="text-center text-md-end">
                            <small
                              className="fw-bold"
                              style={{
                                fontSize: "0.8rem",
                                lineHeight: "1",
                              }}
                            >
                              Quantity
                            </small>
                            <h5
                              style={{
                                color: "#1777FF",
                                fontWeight: "bold",
                                lineHeight: "1",
                                margin: 0,
                                fontSize: "1.1rem",
                              }}
                            >
                              {item.quantity}{" "}
                              {item.quantity > 1 ? "units" : "unit"}
                            </h5>
                          </div>
                        </div>
                        <div
                          className="d-flex flex-column text-end"
                          style={{ minWidth: "160px" }}
                        >
                          <small
                            className="fw-bold"
                            style={{
                              fontSize: "0.8rem",
                              lineHeight: "1",
                            }}
                          >
                            Amount
                          </small>
                          <h5
                            className=" opacity-75"
                            style={{
                              fontWeight: "bold",
                              lineHeight: "1",
                              margin: 0,
                              fontSize: "1.1rem",
                            }}
                          >
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(item.unitPrice * item.quantity)}
                          </h5>
                        </div>
                      </div>

                      {/* Add hr except after the last item */}
                      {index < transfer.items.length - 1 && (
                        <hr className="my-2" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <hr className=" w-100" />
              {transfer.note && (
                <>
                  <div className=" w-100">
                    <strong
                      className=" opacity-75"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Notes
                    </strong>
                    <br />
                    <i style={{ fontSize: "0.8rem" }}>{transfer.note || ""}</i>
                  </div>
                  <hr className=" w-100" />
                </>
              )}
              <div className=" d-flex justify-content-between align-items-center w-100">
                <div className="">
                  {/* <strong className=" fw-bold">Tie to submittal</strong> */}
                  <div className=" d-flex  justify-content-start w-100 gap-4">
                    <div className=" d-flex flex-column">
                      <label htmlFor="submittal" className=" fw-bold">
                        Pick a submittal
                      </label>

                      <Cascader
                        style={{ width: "250px" }}
                        options={options}
                        displayRender={displayRender}
                        onChange={handleChange}
                        popupMenuColumnStyle={{ maxWidth: 350 }}
                        placeholder="Select a submittal"
                        showSearch={{ filter }}
                        onSearch={(value) => console.log(value)}
                        // placement="topLeft"
                      />
                    </div>
                    <div className=" d-flex flex-column">
                      <label htmlFor="actualDeliveryDate" className="fw-bold">
                        Actual Delivery Date
                      </label>
                      <div style={{ display: "inline-block" }}>
                        <DatePicker
                          name="actualDeliveryDate"
                          format="MM-DD-YYYY"
                          defaultValue={dayjs()}
                          style={{
                            width: "130%",
                          }}
                          onChange={(date, dateString) => {
                            if (dateString) {
                              const formattedDate =
                                dayjs(dateString).format("MM-DD-YYYY");
                              setSelectedActualDeliveryDate(formattedDate);
                            } else {
                              setSelectedActualDeliveryDate("");
                            }
                          }}
                          // className={`${Styles.antPickerStyle}`}
                          placeholder="Select Date"
                          disabledDate={(date) => isDateDisabled(date, true)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {transfer.currentStatus === "Delivered" && (
                    <div className="d-flex align-items-center gap-1 text-success">
                      <CheckOutlined
                        className="opacity-75"
                        style={{ fontSize: "0.9rem" }}
                      />
                      <strong style={{ fontSize: "0.85rem" }}>Delivered</strong>
                    </div>
                  )}
                  {transfer.currentStatus === "Cancelled" && (
                    <div className="d-flex align-items-center gap-1 text-danger">
                      <Block
                        className="opacity-75"
                        style={{ fontSize: "0.9rem" }}
                      />
                      <strong style={{ fontSize: "0.85rem" }}>Cancelled</strong>
                    </div>
                  )}
                  {canCancel(transfer) && canUpdate(transfer) && (
                    <div>
                      <label htmlFor="delivery" className=" fw-bold">
                        {/* Action */}
                      </label>
                      <Dropdown.Button
                        type="default"
                        disabled={accessLevel < 2}
                        menu={{
                          items,
                          onClick: ({ key }) =>
                            handleCancelTransfer(transfer, key),
                        }}
                        onClick={() => handleUpdateTransfer(transfer)}
                        style={{ fontSize: "0.8rem" }}
                      >
                        {transfer.currentStatus === "Pending" && (
                          <div className="d-flex align-items-center gap-1">
                            <LocalShippingOutlinedIcon
                              className="opacity-50"
                              style={{ fontSize: "1rem" }}
                            />
                            <span style={{ fontSize: "0.85rem" }}>Ship</span>
                          </div>
                        )}

                        {transfer.currentStatus === "In Transit" && (
                          <div className="d-flex align-items-center gap-1">
                            <span style={{ fontSize: "0.85rem" }}>
                              Mark Delivered
                            </span>
                          </div>
                        )}
                      </Dropdown.Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Card>
        )}
      />
    </div>
  );

  const statusColors = {
    Pending: "orange",
    "In Transit": "blue",
    Transit: "blue",
    Delivered: "green",
    Cancelled: "red",
  };

  const canUpdate = (transfer) => {
    return (
      transfer.currentStatus === "Pending" ||
      transfer.currentStatus === "In Transit"
    );
  };

  const canCancel = (transfer) => {
    return (
      transfer.currentStatus !== "Delivered" &&
      transfer.currentStatus !== "Cancelled"
    );
  };

  const items = [
    {
      key: "cancel",
      icon: <Block />,
      label: "Cancel Transfer",
      danger: true,
      // onClick: () => handleCancelTransfer(transfer),
    },
  ];

  const updateProcLog = () => {
    if (selectedEntryID) {
      const original = projectDetails.content[selectedDivision][
        selectedSubDivision
      ].find((i) => i.entryID === selectedEntryID);

      if (!original) return;

      // create a shallow copy and update it
      const data = [
        {
          ...original,
          ActualDeliveryDate: dayjs(selectedActualDeliveryDate).format(
            "MM-DD-YYYY",
          ),
        },
      ];

      let company_id = AuthStorage.getItem("company_id");
      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");

      let authData = {
        company_id,
        project_id: projectID,
        code,
        loginEmail: email,
      };

      ProjectServices.EditRow(data, authData)
        .then(() => {
          editedItems.forEach((item) => dispatch(EditRow(item)));
          dispatch(reloadProjects());
          // toast.success("Row updated successfully.");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.");
        });
    }
  };

  const handleCancelTransfer = (transfer) => {
    console.log("Cancelling transfer:", transfer);

    if (
      transfer.currentStatus !== "Delivered" &&
      transfer.cancelledStatus === ""
    ) {
      let company_id = AuthStorage.getItem("company_id");
      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");
      let ReqObj = {
        company: company_id,
        project: projectID,
        code,
        loginEmail: email,
        itemID: transfer.transferID,
        status: "Cancelled",
      };
      WarehouseServices.updateTransferInventoryItem(ReqObj)
        .then((res) => {
          toast.success("Status updated successfully");
          transfersToProjectInventoryHistory();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.");
        });
    }
  };

  const handleUpdateTransfer = (transfer) => {
    // console.log("Updating transfer:", transfer);

    if (
      transfer.currentStatus !== "Delivered" &&
      transfer.cancelledStatus === ""
    ) {
      let company_id = AuthStorage.getItem("company_id");
      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");
      let ReqObj = {
        company: company_id,
        project: projectID,
        code,
        loginEmail: email,
        itemID: transfer.transferID,
        status: transfer.currentStatus === "Pending" ? "Transit" : "Delivered",
      };
      WarehouseServices.updateTransferInventoryItem(ReqObj)
        .then((res) => {
          toast.success("Status updated successfully");
          updateProcLog();
          transfersToProjectInventoryHistory();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.");
        });
    }
  };

  const historyTab = (
    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
      <List
        dataSource={itemsShippedHistoryData || []}
        loading={isitemsShippedLoading}
        renderItem={(transfer, index) => (
          <Card
            className=" w-100  bg-light bg-opacity-50"
            title={
              <div className="pt-3 pb-1">
                <div className="d-flex flex-column flex-lg-row justify-content-between mb-2 align-items-center gap-3">
                  {/* Left side - Transfer ID and Status */}
                  <div className="d-flex align-items-center  mb-3 mb-lg-0 ">
                    <Tag
                      className="flex items-center justify-center align-items-center fw-bold"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color={statusColors[transfer.currentStatus] || "default"}
                    >
                      {transfer.currentStatus === "Pending" && (
                        <RestoreIcon
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}

                      {transfer.currentStatus === "In Transit" && (
                        <LocalShippingOutlinedIcon
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}

                      {transfer.currentStatus === "Delivered" && (
                        <Inventory2OutlinedIcon
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}

                      {transfer.currentStatus === "Cancelled" && (
                        <Block
                          style={{
                            color: statusColors[transfer.currentStatus],
                            fontSize: "1.3rem",
                          }}
                        />
                      )}
                    </Tag>

                    <div className="d-flex flex-column justify-content-start gap-0">
                      <div>
                        <h6
                          className="fw-bold m-0 p-0"
                          style={{ fontSize: "0.9rem" }}
                        >
                          Transfer #{transfer.transferID}
                        </h6>
                      </div>
                      <div>
                        <Tag
                          color={
                            statusColors[transfer.currentStatus] || "default"
                          }
                          bordered={false}
                          className="rounded-5"
                          style={{ fontSize: "0.7rem" }}
                        >
                          {transfer.currentStatus}
                        </Tag>
                      </div>
                    </div>
                  </div>

                  {/* Right side  */}
                  <div className="d-flex flex-column flex-md-row gap-3 gap-md-5 justify-content-start justify-content-md-end align-items-start align-items-md-center">
                    <div className="d-flex flex-column text-md-end">
                      <span className="fw-bold fs-6  opacity-75">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(
                          (transfer.items || []).reduce(
                            (sum, item) => sum + item.unitPrice * item.quantity,
                            0,
                          ),
                        )}
                      </span>
                      <small className=" opacity-50">
                        {transfer.createdAt}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            }
            style={{ marginBottom: 16 }}
          >
            <div className=" d-flex justify-content-center align-items-center flex-column">
              <div className=" d-flex w-100 justify-content-md-start align-self-start flex-wrap gap-3 justify-content-start py-0">
                <div>
                  {transfer.items.map((item, index) => (
                    <div key={index}>
                      <div
                        className="d-flex flex-wrap justify-content-start px-1 py-1"
                        style={{ columnGap: "1rem", rowGap: "1rem" }}
                      >
                        {/* Material Info */}
                        <div
                          className="d-md-flex flex-md-row gap-2 align-items-center"
                          style={{ minWidth: "130px" }}
                        >
                          <Inventory2OutlinedIcon
                            style={{ fontSize: "1rem" }}
                            className="opacity-50"
                          />
                          <div className="d-flex flex-column text-start">
                            <small
                              style={{
                                fontSize: "0.85rem",
                                lineHeight: "1.2",
                                fontWeight: "bold",
                              }}
                            >
                              {item.materialName}
                            </small>
                            <small
                              className="opacity-50"
                              style={{
                                fontSize: "0.75rem",
                                lineHeight: "1.2",
                              }}
                            >
                              SKU: {item.sku}
                            </small>
                            {item?.itemVendor ? (
                              <small
                                className="opacity-50"
                                style={{
                                  fontSize: "0.75rem",
                                  lineHeight: "1.2",
                                }}
                              >
                                Vendor: {item.itemVendor}
                              </small>
                            ) : null}
                            <small
                              // className="opacity-50"
                              style={{
                                fontSize: "0.9rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {item?.category || ""}
                            </small>
                            <small
                              // className="opacity-50"
                              style={{
                                fontSize: "0.9rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {item?.subcategory || ""}
                            </small>
                          </div>
                        </div>

                        {/* Location Info */}
                        <div
                          className="d-md-flex flex-md-row gap-2 align-items-center"
                          style={{ minWidth: "130px" }}
                        >
                          <LocationOnOutlinedIcon
                            style={{ fontSize: "1rem" }}
                            className="opacity-50"
                          />
                          <div className="d-flex flex-column text-start">
                            <small
                              style={{
                                fontSize: "0.85rem",
                                lineHeight: "1.2",
                                fontWeight: "bold",
                              }}
                            >
                              {transfer.toLocation}
                            </small>
                            <small
                              className="opacity-75"
                              style={{
                                fontSize: "0.75rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {Object.keys(projectAddressMap).length > 0 ? (
                                projectAddressMap[transfer.toLocation] ||
                                "No address provided"
                              ) : (
                                <Skeleton.Input
                                  style={{ width: 80, height: 12 }}
                                  active
                                  size="small"
                                />
                              )}
                            </small>
                            <small
                              style={{
                                fontSize: "0.75rem",
                                lineHeight: "1.2",
                              }}
                            >
                              {transfer.toSubLocation}
                            </small>
                          </div>
                        </div>

                        {/* Quantity Info */}
                        <div
                          className="d-flex justify-content-end"
                          style={{ minWidth: "160px" }}
                        >
                          <div className="text-center text-md-end">
                            <small
                              className="fw-bold"
                              style={{
                                fontSize: "0.8rem",
                                lineHeight: "1",
                              }}
                            >
                              Quantity
                            </small>
                            <h5
                              style={{
                                color: "#1777FF",
                                fontWeight: "bold",
                                lineHeight: "1",
                                margin: 0,
                                fontSize: "1.1rem",
                              }}
                            >
                              {item.quantity}{" "}
                              {item.quantity > 1 ? "units" : "unit"}
                            </h5>
                          </div>
                        </div>
                        <div
                          className="d-flex flex-column text-end"
                          style={{ minWidth: "160px" }}
                        >
                          <small
                            className="fw-bold"
                            style={{
                              fontSize: "0.8rem",
                              lineHeight: "1",
                            }}
                          >
                            Amount
                          </small>
                          <h5
                            className=" opacity-75"
                            style={{
                              fontWeight: "bold",
                              lineHeight: "1",
                              margin: 0,
                              fontSize: "1.1rem",
                            }}
                          >
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(item.unitPrice * item.quantity)}
                          </h5>
                        </div>
                      </div>

                      {/* Add hr except after the last item */}
                      {index < transfer.items.length - 1 && (
                        <hr className="my-2" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <hr className=" w-100" />
              <div className=" d-flex justify-content-between align-items-center w-100">
                <div className="">
                  <strong
                    className=" opacity-75"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Notes
                  </strong>
                  <br />
                  <i style={{ fontSize: "0.8rem" }}>{transfer.note || ""}</i>
                </div>
                <div>
                  {transfer.currentStatus === "Delivered" && (
                    <div className="d-flex align-items-center gap-1 text-success">
                      <CheckOutlined
                        className="opacity-75"
                        style={{ fontSize: "0.9rem" }}
                      />
                      <strong style={{ fontSize: "0.85rem" }}>Delivered</strong>
                    </div>
                  )}
                  {transfer.currentStatus === "Cancelled" && (
                    <div className="d-flex align-items-center gap-1 text-danger">
                      <Block
                        className="opacity-75"
                        style={{ fontSize: "0.9rem" }}
                      />
                      <strong style={{ fontSize: "0.85rem" }}>Cancelled</strong>
                    </div>
                  )}
                  {canCancel(transfer) && canUpdate(transfer) && (
                    <div>
                      <Dropdown.Button
                        type="default"
                        menu={{
                          items,
                          onClick: ({ key }) =>
                            handleCancelTransfer(transfer, key),
                        }}
                        onClick={() => handleUpdateTransfer(transfer)}
                        style={{ fontSize: "0.8rem" }}
                      >
                        {transfer.currentStatus === "Pending" && (
                          <div className="d-flex align-items-center gap-1">
                            <LocalShippingOutlinedIcon
                              className="opacity-50"
                              style={{ fontSize: "1rem" }}
                            />
                            <span style={{ fontSize: "0.85rem" }}>Ship</span>
                          </div>
                        )}

                        {transfer.currentStatus === "In Transit" && (
                          <div className="d-flex align-items-center gap-1">
                            <span style={{ fontSize: "0.85rem" }}>
                              Mark Delivered
                            </span>
                          </div>
                        )}
                      </Dropdown.Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Card>
        )}
      />
    </div>
  );

  const tabItems = [
    projectDetails && {
      key: "1",
      label: "Pending Transfers",
      children: pendingTransfersTab,
    },
    {
      key: "2",
      label: "History",
      children: historyTab,
    },
  ].filter(Boolean);

  return (
    <Modal
      open={itemsShippedModal}
      onCancel={onCancel}
      footer={null}
      //   title="Items Shipped"
      width={800}
      centered
    >
      {isitemsShippedLoading ? (
        <LoadingComponent />
      ) : (
        <Tabs defaultActiveKey="1" items={tabItems} />
      )}
    </Modal>
  );
}

export default ItemsShippedModal;
